import React, { useEffect, useState } from 'react'
import '../styles/video.css'
import useVideo from '../hooks/useVideo';
import { NavLink } from 'react-router-dom';

const ChallengeVideo = ({ videoUrl }) => {

    const { videoRef, previewRef, timeLineRef, previewTimestamp, isPlaying, playVideo, handleTimeLineProgress, handleMouseSeek, handleClickSeek, handleTimeLinePreview } = useVideo();

    const [openDropDown, setOpenDropDown] = useState(false);

    const handleDropDown = () => {
        setOpenDropDown(prev => !prev);
    }

    return (
        <div className='w-full h-full snap-start relative'>
            {/* video */}
            <video ref={videoRef} onClick={playVideo} className='w-full h-full object-fill z-10 relative' src={videoUrl} onTimeUpdate={handleTimeLineProgress} loop preload='metadata'></video>
            {/* video elements container */}
            <div className='absolute top-0 bottom-0 right-0 left-0 bg-transparent text-white'>
                {/* dropdown box */}
                <span className='absolute right-4 top-4 z-20 flex flex-col' onClick={handleDropDown}>
                    {/* {openDropDown ? <i className="fa-solid fa-xmark text-2xl self-end"></i> : <i className="fa-solid fa-ellipsis-vertical text-2xl self-end"></i>} */}
                    {/* {openDropDown && <ul className='flex flex-col gap-2 py-2 px-4 bg-white shadow rounded-sm text-neutral-500 capitalize divide-y-2'>
                        <li><NavLink to={'/profile'}>my profile</NavLink></li>
                        <li><NavLink to={'/upload'}>upload</NavLink></li>
                        <li><NavLink to={'/'}>description</NavLink></li>
                    </ul>} */}
                </span>
                <div className='video_timeline' ref={timeLineRef} onClick={handleClickSeek} onMouseMove={handleTimeLinePreview} onMouseLeave={handleMouseSeek}>
                    <div ref={previewRef} className='preview_container'><p className='text-center font-semibold text-lg'>{previewTimestamp}</p></div>
                    <span className='preview_pointer'></span>
                </div>
            </div>
            {/* blank screen to show play/pause icon */}
           {isPlaying?null:<div className='bg-black bg-opacity-30 absolute top-0 bottom-0 right-0 left-0 z-20 flex justify-center items-center' onClick={playVideo}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-14 text-white">
                    <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clipRule="evenodd" />
                </svg>
            </div>}
        </div>
    )
}

export default ChallengeVideo